// export default function ({ app }) {
//     if (process.client) {
//         const script = document.createElement('script');
//         script.setAttribute('id', 'facebook-jssdk');
//         script.setAttribute('src', 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js');
//         script.setAttribute('async', 'true');
//         script.setAttribute('crossorigin', 'anonymous');
    
//         const chatbox = document.createElement('div');
//         chatbox.setAttribute('id', 'fb-customer-chat');
//         chatbox.setAttribute('class', 'fb-customerchat');
//         chatbox.setAttribute('page_id', '125303071504889');
//         chatbox.setAttribute('attribution', 'biz_inbox');
    
//         document.body.appendChild(chatbox);
//         document.body.appendChild(script);
//     }
// }